import { Grid } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

import { smallerInputsAndDropdowns } from "../../../../../utils/styles-utils/smallerInputsAndDropdowns/smaller-inputs-and-dropdowns";

export const Container = styled(Grid)({
  margin: "10px 0",
});

export const EventHeader = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "5px 10px",
  backgroundColor: lighten(theme.palette.secondary.light, 0.5),
  borderRadius: "5px",

  ...smallerInputsAndDropdowns,

  svg: {
    fontSize: ".8em",
    color: theme.palette.primary.main,
    visibility: "hidden",
    opacity: "0",
    transition: "all .4s ease",
  },

  "&:hover svg": {
    visibility: "visible",
    opacity: "1",
  },

  "& > .MuiGrid-root:nth-of-type(1)": {
    width: "75%",
    display: "flex",
    gap: "40px",

    ".MuiTypography-root:nth-of-type(1)": {
      width: "350px",
    },

    ".MuiTypography-root:nth-of-type(2)": {
      width: "150px",
    },
  },

  ".MuiAutocomplete-root": {
    width: "35%",
  },
}));

export const Actions = styled(Grid)({
  width: "20%",
  display: "flex",
  justifyContent: "flex-end",
  gap: "20px",
});

export const EventContent = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: theme.palette.background.default,
  padding: "10px 20px",

  "& > .MuiGrid-root:first-of-type .MuiButton-root": {
    color: theme.palette.primary.main,
    border: "none",
  },
}));

export const FilesList = styled(Grid)(({ theme }) => ({
  display: "flex",
  flex: "1",
  alignItems: "center",
  gap: "15px",
  marginInlineStart: "50px",

  ".MuiGrid-root": {
    display: "flex",
    flexFlow: "column",
    alignItems: "center",

    svg: {
      fontSize: "1.8em",
      color: theme.palette.primary.main,
    },

    ".MuiTypography-root": {
      fontSize: ".7em",
    },
  },
}));

export const FilesInfo = styled(Grid)(({ theme }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",

  ".MuiGrid-root": {
    visibility: "hidden",
    opacity: 0,
    transition: "all .3s ease",
    border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    backgroundColor: lighten(theme.palette.secondary.light, 0.5),
    padding: "10px",
    position: "absolute",
    bottom: "40px",
    right: 0,
    zIndex: 99,
  },

  ".MuiButton-root:hover + .MuiGrid-root, .MuiGrid-root:hover": {
    visibility: "visible",
    opacity: 1,
  },
}));
